const USERS_KEY = 'shushi_users'
const CURRENT_USER_KEY = 'shushi_current_user'

function getUsers() {
  try {
    return JSON.parse(localStorage.getItem(USERS_KEY) || '[]')
  } catch (e) {
    return []
  }
}

function saveUsers(users) {
  localStorage.setItem(USERS_KEY, JSON.stringify(users))
}

export function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem(CURRENT_USER_KEY) || 'null')
  } catch (e) {
    return null
  }
}

export function isLoggedIn() {
  return !!getCurrentUser()
}

export function register({ account, password, name, email, phone }) {
  const users = getUsers()
  if (users.some((u) => u.account === account)) {
    return { ok: false, message: '该账号已注册' }
  }
  const user = { account, password, name, email, phone }
  users.push(user)
  saveUsers(users)
  localStorage.setItem(CURRENT_USER_KEY, JSON.stringify({
    account: user.account,
    name: user.name,
    email: user.email,
    phone: user.phone,
  }))
  return { ok: true, message: '注册成功' }
}

export function login({ account, password }) {
  const users = getUsers()
  const user = users.find((u) => u.account === account && u.password === password)
  if (!user) {
    return { ok: false, message: '账号或密码错误' }
  }
  localStorage.setItem(CURRENT_USER_KEY, JSON.stringify({
    account: user.account,
    name: user.name,
    email: user.email,
    phone: user.phone,
  }))
  return { ok: true, message: '登录成功' }
}

export function logout() {
  localStorage.removeItem(CURRENT_USER_KEY)
}
